export default __webpack_public_path__ + "static/media/shriya.14b1ac9c.jpeg";